import { startApplicationModal } from "./application-modal";
// Imported rather than read off a data attribute: webpack resolves these to the very same URLs
// s-game-modal.scss uses for .loading-note. copyFiles also emits a second, differently pathed
// copy of every image (build/images/game-modal/…), and preloading that one would warm a cache
// entry the loading screen never requests.
import noteWhiteSrc from "../../../images/game-modal/note-white.svg";
import noteRedSrc from "../../../images/game-modal/note-red.svg";

$(function () {
    const inputs = {
        billNr: $('[name="personal_data[billNr]"]'),
        billDate: $('[name="personal_data[billDate]"]'),
        billPos: $('[name="personal_data[billPos]"]'),
        billNip: $('[name="personal_data[billNip]"]'),
    }

    for (const [key, input] of Object.entries(inputs)) {
        if (input.length) {
            input.closest('.form-group').append(`
<button
  type="button"
  class="btn btn-input-hint-modal"
  data-bs-toggle="modal"
  data-bs-target="#modal-hint-form-application-${key}"
>
<i class="fa-solid fa-question" />
</button>`)
        }
    }
})

$('.application-form').on('submit-success', function(event, data, xhr) {
    event.assert(xhr.status == 201 && data.status == 'OK');

    // Hand off to the multi-step, uncloseable game modal instead of swapping the form
    // content. preventDefault() stops ajax-form's post-handler form.reset()/redirect.
    event.preventDefault();
    startApplicationModal(data);
});

$('[name="personal_data[billType]"]').on('change', function() {
    // Default: billPos (Numer kasy) enabled. Checking the billType control disables it; unchecking re-enables.
    $('[name="personal_data[billPos]"]', this.form.elements).closest('.form-group').prop('disabled', this.checked);
}).trigger('change');

// Preload the large modal background and the loading screen's note icons as soon as the user
// starts filling the bill details, so they are cached by the time the modal opens. The notes are
// only ever referenced from CSS, so nothing would fetch them before the loading screen paints.
(function preloadModalAssets() {
    const $modal = $('#modal-form-application');
    if (!$modal.length) {
        return;
    }

    const sources = [$modal.data('bg-src'), noteWhiteSrc, noteRedSrc].filter(Boolean);
    if (!sources.length) {
        return;
    }

    const billFields = [
        'billType', 'billNr', 'billDate', 'billNip', 'billPos',
    ].map(name => `[name="personal_data[${name}]"]`).join(', ');

    let preloaded = false;
    $(document).on('focusin input change', billFields, function() {
        if (preloaded) {
            return;
        }
        preloaded = true;
        sources.forEach((src) => {
            new Image().src = src;
        });
    });
})();